const propelInit = function() {
const tabBlocks = document.querySelectorAll('.block-tab-side-tile');

tabBlocks.forEach((tabBlock) => {
	const toggleTab = (e) => {
		e.preventDefault();

		const currentTabButton = e.currentTarget;

		tabButtons.forEach((tabButton) => {
			if (currentTabButton === tabButton) {
				return;
			}

			tabButton.classList.remove('active');
		});

		currentTabButton.classList.add('active');
	};

	const tabButtons = tabBlock.querySelectorAll(
		'.block-tab-side-tile-tab__button'
	);

	tabButtons.forEach((tabButton) => {
		tabButton.addEventListener('click', toggleTab);
		tabButton.addEventListener('focus', toggleTab);
	});
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['tab-side-tile'] = window.propel.blocks['tab-side-tile'] || {};
window.propel.blocks['tab-side-tile'].script = propelInit;
